import wordpressApi from '../services/wordpressApi';

let postsCache = null;
let postsCacheTime = 0;
const CACHE_DURATION = 5 * 60 * 1000;

export async function getAllPosts() {
  if (postsCache && Date.now() - postsCacheTime < CACHE_DURATION) return postsCache;

  const posts = await wordpressApi.getAllPosts();
  if (posts.length) {
    postsCache = posts;
    postsCacheTime = Date.now();
  }
  return posts;
}

export async function getPostBySlug(slug) {
  return wordpressApi.getPostBySlug(slug);
}

export async function searchPosts(query) {
  return wordpressApi.searchPosts(query);
}

export function clearCache() {
  postsCache = null;
  postsCacheTime = 0;
}
